import React from 'react';

var ArrowLast = function ArrowLast(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.586 12l-6.293 6.293a1 1 0 0 0 1.414 1.414l7-7a1 1 0 0 0 0-1.414l-7-7a1 1 0 0 0-1.414 1.414L11.586 12zM18 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM17 5v14h2V5h-2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

ArrowLast.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { ArrowLast as icon };
export default iconHandler(ArrowLast);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/ArrowLast.js
// module id = 579
// module chunks = 0